import React, { useEffect, useState } from "react";
import Column from "@amzn/meridian/column";
import VerificationWindow from "./verificationWindow/verificationWindow";
import { getEmployeeTCPRoles } from "../resources/EmployeeResource";
import { TCP_ROLE } from "../util/Constants";
import Alert from "@amzn/meridian/alert";

function DolphinVerification() {
  const [isUserAuthorized, setIsUserAuthorized] = useState(null);

  useEffect(() => {
    (async () => {
      const roles = await getEmployeeTCPRoles();
      if (roles && roles.includes(TCP_ROLE.WAREHOUSE_MANAGER)) {
        console.log(
          "User has required permission so set IsUserAuthorized as true",
        );
        setIsUserAuthorized(true);
      } else {
        console.log(
          "User doesn't have required permission so set IsUserAuthorized as false",
        );
        setIsUserAuthorized(false);
      }
    })();
  }, []);

  if (isUserAuthorized === true) {
    // User does have requried perssion so display Dolphin Verification page
    return (
      <Column spacingInset="medium">
        <VerificationWindow />
      </Column>
    );
  } else if (isUserAuthorized === false) {
    // User doesn't have required permission so show alert message
    return (
      <Alert size="large">
        {" "}
        Not authorized, please reach out to your manager for Dolphin
        Verification{" "}
      </Alert>
    );
  } else {
    // [Initialize Phase] Role verification is not completed yet so showing blank page
    return <Column />;
  }
}

export default DolphinVerification;



// WEBPACK FOOTER //
// ./src/components/dolphinVerification/DolphinVerification.js